import styled from '@emotion/styled';
import {
  OL_COLOUR_BLACK_10,
  OL_COLOUR_BLACK_4_HEX,
  OL_COLOUR_TOMAHTO,
} from 'src/web/components/Style/colours';
import { Button } from 'src/web/components/Buttons/Button/Button';
import { TextField } from 'src/web/components/TextField/component';
import { FileField } from 'src/web/components/FileField/component';
import { MIXIN_ANCHOR_BUTTON } from 'src/web/components/Style/mixins';
import { SingleSelect } from 'src/web/components/Input/DropdownsOld/SingleSelect';

export const StyledInstitutionTable = styled('table')(
  ({
    cellBordered,
    greyedRightmostColumn,
  }: {
    cellBordered?: boolean;
    greyedRightmostColumn?: boolean;
  }) => ({
    margin: '8px 0',
    display: 'block',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    paddingBottom: 44, // quick fix for select component being cut off inside the table
    marginBottom: -44,
    width: '100%',
    thead: {
      borderBottom: `1px solid ${OL_COLOUR_BLACK_10}`,
      th: {
        fontWeight: 600,
        background: OL_COLOUR_BLACK_4_HEX,
        textAlign: 'left',
      },
    },
    'td, th': {
      '&:first-child': {
        background: greyedRightmostColumn ? OL_COLOUR_BLACK_4_HEX : 'auto',
      },
      border: cellBordered ? `1px solid ${OL_COLOUR_BLACK_10}` : 'none',
      padding: 16,
    },
  })
);

export const Header = styled('div')({
  fontSize: 20,
  fontWeight: 600,
  margin: '20px 0',
});

export const StyledEmailTextField = styled(TextField)({
  width: 600,
  marginRight: 8,
});

export const EmailOptionWrapper = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
  marginBottom: 16,
});

export const StyledButton = styled(Button)({
  button: {
    color: 'red',
    height: 39,
    fontSize: 14,
  },
});

export const DownloadTemplateSpan = styled('span')({
  marginLeft: 20,
  a: {
    marginRight: 8,
  },
});

export const StyledCsvField = styled(FileField)({
  display: 'inline-block',
  width: 300,
});

export const CsvOptionWrapper = styled('div')({});

export const DialogBox = styled('div')({
  margin: '8px 0',
  padding: 16,
  background: OL_COLOUR_BLACK_4_HEX,
  fontWeight: 600,
});

export const ErrorFieldMessage = styled('div')({
  fontWeight: 600,
});

export const ViewTableButton = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
});

export const ButtonActionWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});

export const AccountCreationOptionWrapper = styled('div')({
  margin: '32px 0',
});

export const ErrorText = styled('span')({
  color: OL_COLOUR_TOMAHTO,
  marginRight: 8,
});

export const RoleSelect = styled(SingleSelect)({
  width: 220,
  '.react-selectize.root-node': {
    width: 'auto',
  },
});

export const StyledTooltipOverlay = styled('div')({
  maxWidth: 200,
});

export const StyledTextField = styled(TextField)({
  minWidth: 150,
});
